const _excluded = ["emailToInclude", "iconStyles"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Button } from "./Button";
import { defaultIconStyles } from "./defaultButtonIconStyles";
export function AddUserButton(_ref) {
  let {
      emailToInclude,
      iconStyles
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!emailToInclude) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "light",
    className: "p-1 d-inline-flex rounded-circle"
  }, props), /*#__PURE__*/React.createElement("span", {
    style: iconStyles || defaultIconStyles,
    className: "material-icons md-18 text-primary rounded-circle mx-auto"
  }, "person_add"));
}